import { Apis } from "../../lib/Apis";

export const useOrders = () => {
    const getORders = async (setOrderData, params = {}, offset = 0, limit = 9) => {
        try {
            const requestParams = {
                ...params,
                offset,
                limit
            };
            const response = await Apis.getOrders(requestParams);
            setOrderData(response.data.ordersData);
            return response.data;
        } catch (error) {
            console.error("Error fetching orders:", error);
            throw error;
        }
    }

    const updateOrderStatus = async (orderId, status) => {
        try {
            const body = { status };
            const response = await Apis.updateOrderStatus(orderId, body);
            return response;
        } catch (error) {
            console.error("Error updating order status:", error);
            throw error;
        }
    }

    return { getORders, updateOrderStatus };
}